import styled from 'styled-components';
var Paragraph = styled.p.withConfig({
  displayName: "AvailabilityFiltersstyles__Paragraph",
  componentId: "sc-22duni-0"
})(["font-weight:", ";font-family:", ";font-size:20px;padding-bottom:10px;margin:0 15px;@media (min-width:$screen-sm-min){margin:0 25px;}"], function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.font.family.brand;
});
var Buttons = styled.div.withConfig({
  displayName: "AvailabilityFiltersstyles__Buttons",
  componentId: "sc-22duni-1"
})(["display:flex;flex-direction:row;align-items:stretch;border-radius:0;"]);
export { Paragraph, Buttons };